export default {
  apiPrefix: '/api/v1/',
};
